import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../../store/useUserStore';
import { useFavoriteVideosQuery } from '../../../queries';
import Url from '../../../data/url';
import ImgNoThumbnail from '../../../assets/image/img_video_no_thumbnail.png';

import FullHeightContainer from '../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';

function FavoriteVideos() {
  const navigate = useNavigate();
  const user = useUserStore();

  const { data: videos = [] } = useFavoriteVideosQuery(user.id as number, { enabled: !!user.id });

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title="즐겨찾는 항목" onClickPrev={() => navigate(-1)} />
      <div className="pageInner" style={{ padding: '0 0 50px 0' }}>
        {videos.length >= 1 ? (
          <div className="grid grid-cols-3 gap-[5px] px-[20px]">
            {videos.map((video, index) => (
              <button
                type="button"
                onClick={() =>
                  navigate(Url.HistoryWatchVideo, { state: { videos, videoIndex: index } })
                }
                key={video.mediaId}
                style={{ aspectRatio: '1 / 1' }}
                className="w-full bg-[#F8F8F8] flex items-center justify-center text-[#1C1C1C] text-[14px] font-[500]"
              >
                <img
                  src={video.thumbnailUrl || ImgNoThumbnail}
                  alt={`Video ${video.mediaId}`}
                  className="w-full h-full object-cover rounded-[10px]"
                />
              </button>
            ))}
          </div>
        ) : (
          <div className="w-full h-[200px] flex justify-center items-center text-[gray] text-center">
            즐겨찾기 비디오가 없습니다.
          </div>
        )}
      </div>
    </FullHeightContainer>
  );
}

export default FavoriteVideos;
